import { render, staticRenderFns } from "./my-correction.vue?vue&type=template&id=5695e755&scoped=true&"
import script from "./my-correction.vue?vue&type=script&lang=js&"
export * from "./my-correction.vue?vue&type=script&lang=js&"
import style0 from "./my-correction.vue?vue&type=style&index=0&id=5695e755&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5695e755",
  null
  
)

export default component.exports